const colors = { 'C#': '#3b82f6', Java: '#8b5cf6', Python: '#22c55e', JavaScript: '#f59e0b', 'R-Sql': '#06b6d4', '3D Graphics': '#ec4899', Cloud: '#0ea5e9' };
const dateLabel = value => {
  const date = new Date(value);
  return value && Number.isFinite(date.getTime()) ? `${date.getFullYear()}년 ${date.getMonth() + 1}월` : '정보 없음';
};
const numberOrNull = value => value !== null && value !== undefined && value !== '' && Number.isFinite(Number(value)) ? Number(value) : null;

export function baseCourse(product) {
  const isService = ['service', 'donation'].includes(product.offer_kind);
  return {
    id: product.prod_id, type_id: product.prod_type, offerKind: product.offer_kind || 'course', isService,
    title: product.prod_name, description: product.prod_desc || '', category: product.prod_category,
    categoryColor: colors[product.prod_category] || '#64748b', image: product.image_url,
    price: numberOrNull(product.prod_price), originalPrice: null, discount: null, rating: null, students: null,
    duration: product.duration || '정보 없음', lastUpdated: dateLabel(product.updated_at || product.created_at),
    curriculum: [], instructor: { name: product.author_name || '정보 없음', role: isService ? '제공자' : '강사', avatar: '', bio: '' },
    detailedDescription: product.prod_desc || '', descriptionIsHtml: false, reviews: [], supplementaryUnavailable: false
  };
}

export async function loadCourseDetail(productId, { onBase, signal, fetcher = fetch } = {}) {
  const read = async path => {
    const response = await fetcher(path, { credentials: 'include', cache: 'no-store', signal });
    if (!response.ok) throw new Error(`DETAIL_HTTP_${response.status}`);
    return response.json();
  };
  const product = await read(`/api/getProductById?prod_id=${encodeURIComponent(productId)}`);
  if (!product || typeof product !== 'object' || !product.prod_id) throw new Error('PRODUCT_NOT_FOUND');
  const base = baseCourse(product);
  onBase?.(base);
  if (base.isService) return base;

  const results = await Promise.allSettled([
    read(`/api/getProductDetail?prod_id=${encodeURIComponent(productId)}`),
    read(`/api/getProductCurriculum?prod_id=${encodeURIComponent(productId)}`),
    read(`/api/getProductReviews?prod_id=${encodeURIComponent(productId)}`)
  ]);
  if (signal?.aborted) return base;
  const value = (index, fallback) => results[index].status === 'fulfilled' ? results[index].value : fallback;
  const rawDetail = value(0, null);
  const detail = rawDetail && typeof rawDetail === 'object' && !Array.isArray(rawDetail) ? rawDetail : {};
  const rawCurriculum = value(1, []), rawReviews = value(2, []);
  const curriculum = Array.isArray(rawCurriculum) ? rawCurriculum : [];
  const reviews = Array.isArray(rawReviews) ? rawReviews : [];
  let unavailable = results.some(row => row.status === 'rejected') || !rawDetail || !Array.isArray(rawCurriculum) || !Array.isArray(rawReviews);
  const sections = await Promise.all(curriculum.map(async section => {
    try {
      const lessons = await read(`/api/getProductLectures?curriculum_id=${encodeURIComponent(section.curriculum_id)}`);
      if (!Array.isArray(lessons)) throw new Error('INVALID_LECTURES');
      return { title: section.section_title, lessons: lessons.map(lesson => ({ title: lesson.lecture_title, duration: lesson.duration_minutes ? `${lesson.duration_minutes}:00` : '00:00' })) };
    } catch (_) { unavailable = true; return { title: section.section_title, lessons: [] }; }
  }));
  const ratings = reviews.map(review => numberOrNull(review.rating)).filter(rating => rating !== null);
  return {
    ...base, curriculum: sections, reviews,
    rating: ratings.length ? (ratings.reduce((sum, rating) => sum + rating, 0) / ratings.length).toFixed(1) : null,
    duration: detail.total_hours ? `${detail.total_hours}시간` : base.duration,
    lastUpdated: detail.updated_at ? dateLabel(detail.updated_at) : base.lastUpdated,
    instructor: { ...base.instructor, name: detail.instructor_name || base.instructor.name, bio: detail.instructor_bio || '' },
    detailedDescription: detail.detailed_description || base.detailedDescription,
    descriptionIsHtml: Boolean(detail.detailed_description), supplementaryUnavailable: unavailable
  };
}
